export default __webpack_public_path__ + "static/media/error-cross-neutral.8ebf737d.svg";